// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__2UlBQ","inputWrap":"styles_inputWrap__1H7nS","input":"styles_input__2RPGB"};